/** Contenu aligné sur le Formulaire Info Santé FFTRI (FIS 2024). */
export const FFTRI_FIS_PDF_URL = "/fftri-formulaire-info-sante-2024.pdf";

export const FFTRI_FIS_INTRO =
  "Dans le cadre de la loi Sport du 2 mars 2022, la Fédération Française de Triathlon, sur avis favorable de sa Commission Nationale Médicale rendu le 09 février 2023, a décidé de supprimer la présentation d'un certificat médical d'absence de contre-indication à la pratique sportive et le remplacer par ce formulaire.";

export const HEALTH_FORM_SECTIONS_FFTRI = [
  {
    id: "alerte",
    title: "ALERTE",
    alertType: "error",
    intro: "Au cours des 12 derniers mois, avez-vous ressenti/présenté :",
    questions: [
      "Une douleur dans la poitrine après l'effort ?",
      "Des palpitations (perception inhabituelle des battements cardiaques — irréguliers et/ou rapides — de durée brève ou plus ou moins prolongée) ?",
      "Un malaise durant un effort ?",
      "Une perte de connaissance brutale, que ce soit au repos ou à l'effort ?",
      "Un essoufflement inhabituel à l'effort ?",
    ],
    warning:
      "Si vous avez répondu positivement à l'une des questions précédentes, il est indispensable et URGENT de consulter un médecin avant de poursuivre l'entraînement et la compétition. Pour obtenir davantage d'information sur le risque cardio-vasculaire et la pratique sportive, vous pouvez consulter le contenu suivant",
    infoLinks: [
      {
        label: "FICHE INFO — Risque cardio-vasculaire et pratique sportive",
        href: "https://docs.google.com/presentation/d/1WZl-qKTVZVxJ-8oTnOJkb-NK0lNIGJZkAcU0KjWHhLg/edit",
      },
    ],
    checkboxes: [
      {
        key: "alerte_symptomes_cardio",
        label:
          "En cochant cette case, j'indique comprendre que ces symptômes peuvent être des signes de pathologie cardiaque à risque pour ma santé, et représenter potentiellement un risque vital.",
      },
      {
        key: "alerte_bilan_medical",
        label:
          "En cochant cette case, j'indique comprendre la nécessité de réaliser un bilan médical en cas de symptômes cités ci-dessus et non encore explorés par un médecin.",
      },
    ],
  },
  {
    id: "attention",
    title: "ATTENTION",
    alertType: "warning",
    intro: "Est-ce que :",
    questions: [
      "Un membre de votre famille (parent, frère, sœur, enfant) est-il décédé subitement d'une cause cardiaque ou d'une autre cause inexpliquée ?",
      "Un membre de votre famille (parent, frère, sœur) a-t-il présenté une maladie cardiaque avant l'âge de 35 ans ?",
      "Vous avez repris une activité physique intensive sans réaliser un bilan médical après 45 ans (femme) / 35 ans (homme) pour évaluer votre risque cardio-vasculaire ?",
      {
        text: "Vous présentez au moins deux de ces facteurs de risque cardio-vasculaire, à savoir :",
        subItems: [
          "Âge supérieur à 50 ans",
          "Tabagisme actif ou sevré depuis moins de 3 ans",
          "Diabète quel que soit le type",
          "Anomalie du cholestérol",
          "Hypertension artérielle",
        ],
      },
      "Vous êtes suivi(e) pour une maladie chronique ?",
      "Vous poursuivez la compétition et/ou l'activité physique intensive après 60 ans ?",
      "Vous avez expérimenté une baisse inexpliquée de performance au cours des douze derniers mois ?",
    ],
    warning:
      "Si vous avez répondu positivement à l'une des questions précédentes, il est nécessaire d'avoir pris un avis auprès d'un médecin voire de réaliser un bilan médical avant la poursuite de votre pratique du triathlon et de ses disciplines enchaînées, avec ou sans compétition.",
    infoLinks: [
      {
        label: "Le triathlon santé (Wikitri)",
        href: "https://wikitri.fftri.com/le-triathlon-sante/",
      },
    ],
    checkboxes: [
      {
        key: "attention_antecedents_risque",
        label:
          "En cochant cette case, j'indique comprendre que certains antécédents familiaux, facteurs de risque cardio-vasculaire ou qu'une maladie chronique, peuvent entraîner une majoration du risque lié à la pratique du triathlon et de ses disciplines enchaînées, et qu'ils doivent faire prendre un avis auprès d'un médecin pour une pratique sécurisée.",
      },
      {
        key: "attention_bilan_ages",
        label:
          "En cochant cette case, j'indique comprendre qu'un bilan médical à certains âges de la vie est nécessaire pour faire le point sur mon état de santé, sur ma pratique du triathlon et de ses disciplines enchaînées ainsi que sur les risques liés à une pratique avec intensité.",
      },
      {
        key: "attention_regles_cardio_sport",
        label:
          "En cochant cette case, je m'engage à appliquer les 10 règles de bonne pratique du sport éditées par le Club des Cardiologues du Sport.",
        link: {
          label: "consulter les 10 règles d'or",
          href: "https://www.clubcardiosport.com/10-regles-or",
        },
      },
    ],
  },
  {
    id: "vigilance",
    title: "VIGILANCE",
    alertType: "info",
    intro: "Si :",
    questions: [
      "Vous n'avez jamais réalisé d'électrocardiogramme dans votre vie",
      "Au cours des 12 derniers mois, vous avez arrêté le sport plus de 30 jours pour des raisons de santé",
      "Vous pensez avoir un problème avec la nourriture ou si on vous a déjà fait la remarque à ce sujet",
      "Vous êtes une femme et que vous n'avez plus vos règles depuis plus de 3 mois",
      "Vous avez eu un traumatisme crânien ou une commotion cérébrale",
      "Vous pensez tout simplement avoir besoin d'un avis médical pour poursuivre votre pratique sportive",
    ],
    warning:
      "Alors, il est recommandé de consulter votre médecin pour aborder ces éléments voire réaliser un bilan, avant de poursuivre l'intensification de votre pratique.",
    infoLinks: [
      {
        label: "FICHE INFO — Risques médicaux",
        href: "https://www.fftri.com/actualite/medecine-du-triathlon-pratiques-recommandations-prevention/",
      },
    ],
    checkboxes: [
      {
        key: "vigilance_situations_risque",
        label:
          "En cochant cette case, j'indique comprendre que certaines situations ou symptômes peuvent entraîner un risque pour ma santé et/ou pour mes performances.",
      },
    ],
  },
  {
    id: "bonnes_pratiques",
    title: "BONNES PRATIQUES",
    alertType: "success",
    intro:
      "La Fédération Française de Triathlon met à disposition de ses licencié(e)s et des compétitrices/teurs des informations / recommandations sur les sujets suivants (voir annexe et/ou lien internet) :",
    resources: [
      { label: "Troubles musculo-squelettiques", href: "https://docs.google.com/presentation/d/1BjszZOH-0LV8P0wSplQVSap5nP-y4MvOxO9zriy-5Zc/edit?slide=id.p#slide=id.p" },
      { label: "Nutrition (annexe)", href: "https://docs.google.com/presentation/d/1BjszZOH-0LV8P0wSplQVSap5nP-y4MvOxO9zriy-5Zc/edit?slide=id.p#slide=id.p" },
      { label: "Usage des compléments alimentaires (annexe)", href: "https://docs.google.com/presentation/d/1BjszZOH-0LV8P0wSplQVSap5nP-y4MvOxO9zriy-5Zc/edit?slide=id.p#slide=id.p" },
      {
        label: "Lutte contre le dopage",
        href: "https://www.fftri.com/nos-engagements/prevention-dopage/",
      },
      {
        label: "Leptospirose",
        href: "https://sante.gouv.fr/IMG/pdf/triptyque_leptospirose_mise_a_jour_23_mai_2022_.pdf",
      },
    ],
    footer:
      "Enfin, parce que trois gestes simples — masser / appeler / défibriller — peuvent sauver des vies y compris dans le sport, la Fédération Française de Triathlon vous encourage à vous former aux gestes qui sauvent : « chaque minute de gagnée, c'est 10 % de chance de survie en plus. » Parlez-en autour de vous.",
    footerLink: {
      label: "Gestes qui sauvent (service-public.fr)",
      href: "https://www.service-public.fr/particuliers/actualites/A16630",
    },
    checkboxes: [
      {
        key: "bonnes_pratiques_prise_connaissance",
        label:
          "En cochant cette case, j'indique avoir pris connaissance et compris toutes les informations et alertes indiquées lors des différentes étapes de ce Formulaire Info Santé de la Fédération Française de Triathlon.",
      },
      {
        key: "bonnes_pratiques_dispositions_medicales",
        label:
          "En cochant cette case, j'indique prendre ou avoir pris les dispositions nécessaires en conséquence — consultation médicale adaptée et, le cas échéant, arrêt temporaire de l'activité sportive — me permettant de m'entraîner ou de participer à une compétition de triathlon et de ses disciplines enchaînées, en limitant au maximum le risque pour ma santé.",
      },
    ],
  },
];

export function getHealthFormCheckboxKeys() {
  return HEALTH_FORM_SECTIONS_FFTRI.flatMap((section) =>
    section.checkboxes.map((item) => item.key)
  );
}

export function createEmptyHealthFormFFTRI() {
  const form = {};
  for (const key of getHealthFormCheckboxKeys()) {
    form[key] = false;
  }
  return form;
}

export function isHealthFormFFTRIComplete(healthForm) {
  if (!healthForm) return false;
  for (const key of getHealthFormCheckboxKeys()) {
    if (!healthForm[key]) return false;
  }
  return true;
}
